import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../lib/api';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (sessionId) {
      handleAuth(sessionId);
    } else {
      navigate('/auth');
    }
  }, [location]);

  const handleAuth = async (sessionId) => {
    try {
      const res = await api.post('/api/auth/google', { session_id: sessionId });
      localStorage.setItem('token', res.data.access_token);
      toast.success("Welcome back!");
      
      // Check for stored redirect URL (from invite links)
      const redirectUrl = sessionStorage.getItem('authRedirect');
      if (redirectUrl) {
        sessionStorage.removeItem('authRedirect');
        // Use window.location.href to ensure proper navigation after auth state update
        window.location.href = redirectUrl;
      } else {
        window.location.href = '/dashboard';
      }
    } catch (e) {
      console.error(e);
      toast.error("Authentication failed");
      navigate('/auth');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="text-center animate-pulse">
        <h2 className="text-xl font-semibold">Authenticating...</h2>
      </div>
    </div>
  );
}
